<template>
	<div class="home-page" @click="closeAllBox" @contextmenu="closeAllBox">
		<div class="app-container">
		<!-- 桌面端侧边导航栏 -->
			<div v-if="configStore.isDesktop" class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<div class="avater" @click.stop="showUserProfile($event)">
							<head-image :name="displayNickName" :size="44" :url="mine.headImageThumb">
							</head-image>
							<div v-if="displayUserName" class="avater-tenant" :title="displayUserName">
								<span>{{ displayUserName }}</span>
							</div>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'" data-testid="nav-chat">
								<div class="menu-item">
									<span class="menu-item__icon icon iconfont icon-chat"></span>
									<span class="menu-label">会话</span>
									<div v-show="unreadCount > 0" class="unread-text">{{ formatNavBadgeCount(unreadCount) }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'" data-testid="nav-friend">
								<div class="menu-item">
									<span class="menu-item__icon menu-item__icon--friend icon iconfont icon-friend"></span>
									<span class="menu-label">联系人</span>
									<div v-show="recvCount > 0" class="unread-text">{{ formatNavBadgeCount(recvCount) }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'" data-testid="nav-group">
								<div class="menu-item">
									<span class="menu-item__icon menu-item__icon--group icon iconfont icon-group"></span>
									<span class="menu-label">群管理</span>
								</div>
							</router-link>
						</div>
					</div>

					<div class="bottom">
						<div class="bottom-item" @click="onToggleTheme" :title="themeTitle">
							<i :class="['bottom-item__icon', themeIcon]"></i>
						</div>
						<el-popover
							v-model="settingsVisible"
							ref="settingsPopover"
							popper-class="home-settings-popper"
							placement="right-end"
							trigger="click"
							width="188"
						>
							<settings-panel
								:visible="settingsVisible"
								@request-close="closeSettingsPanel"
								@clear-local-cache="onSettingsClearLocalCache"
								@logout="onSettingsLogout"
							></settings-panel>
							<div
								slot="reference"
								class="bottom-item"
								:class="{ 'bottom-item--active': settingsVisible }"
								title="设置"
							>
								<span class="bottom-item__icon icon iconfont icon-setting"></span>
							</div>
						</el-popover>
					</div>
				</div>
			</div>
			<!-- 移动端/平板端顶部栏 -->
			<div v-if="!configStore.isDesktop" class="mobile-header-bar" :class="mobileChromeClass">
				<div class="mobile-header-left">
					<div class="mobile-header-avatar" @click.stop="showUserProfile($event)">
						<head-image :name="displayNickName" :size="36" :url="mine.headImageThumb"></head-image>
					</div>
					<div class="mobile-header-info">
						<span class="mobile-header-title">{{ currentRouteTitle }}</span>
						<div v-if="displayUserName" class="mobile-header-tenant" :title="displayUserName">
							<span>{{ displayUserName }}</span>
						</div>
					</div>
				</div>
				<div class="mobile-header-right">
					<div class="mobile-header-btn" @click="onToggleTheme" :title="themeTitle">
						<i :class="themeIcon"></i>
					</div>
					<div class="mobile-header-btn" @click="toggleSettingsPanel" title="设置">
						<span class="icon iconfont icon-setting"></span>
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view ref="activeView"></router-view>
			</div>
			<!-- 移动端/平板端底部 tab bar -->
			<div v-if="!configStore.isDesktop" class="mobile-tab-bar" :class="mobileChromeClass">
				<router-link class="tab-item" v-bind:to="'/home/chat'" data-testid="tab-chat">
					<span class="tab-item__icon icon iconfont icon-chat"></span>
					<span class="tab-label">会话</span>
					<div v-show="unreadCount > 0" class="tab-badge">{{ formatNavBadgeCount(unreadCount) }}</div>
				</router-link>
				<router-link class="tab-item" v-bind:to="'/home/friend'" data-testid="tab-friend">
					<span class="tab-item__icon tab-item__icon--friend icon iconfont icon-friend"></span>
					<span class="tab-label">联系人</span>
					<div v-show="recvCount > 0" class="tab-badge">{{ formatNavBadgeCount(recvCount) }}</div>
				</router-link>
				<router-link class="tab-item" v-bind:to="'/home/group'" data-testid="tab-group">
					<span class="tab-item__icon tab-item__icon--group icon iconfont icon-group"></span>
					<span class="tab-label">群管理</span>
				</router-link>
			</div>
			<el-drawer
				v-if="!configStore.isDesktop"
				:visible.sync="settingsVisible"
				title="设置"
				direction="rtl"
				:size="settingsDrawerSize"
				:append-to-body="true"
				custom-class="home-settings-drawer"
			>
				<settings-panel
					:visible="settingsVisible"
					:is-mobile="true"
					@request-close="closeSettingsPanel"
					@clear-local-cache="onSettingsClearLocalCache"
					@logout="onSettingsLogout"
				></settings-panel>
			</el-drawer>
			<user-info ref="userInfo"></user-info>
			<group-info ref="groupInfo"></group-info>
			<full-image ref="fullImage"></full-image>
			<full-video ref="fullVideo"></full-video>
			<preview-file ref="previewFile"></preview-file>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
			<user-profile-card ref="userProfileCard"></user-profile-card>
			<app-update-dialog></app-update-dialog>
		</div>
	</div>
</template>

<script>
import { clearAuthSession } from '../api/authSession';
import HeadImage from '../components/common/HeadImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import FullImage from '../components/common/FullImage.vue';
import FullVideo from '../components/common/FullVideo.vue';
import PreviewFile from '../components/common/PreviewFile.vue';
import { syncWorkspaceWindow } from '../utils/authWindow';
import { dismissStack, resolveZIndex } from '../utils/dismissStack';
import { resolveGroupChatDisplayName, resolvePrivateDisplayName } from '../utils/identityDisplay.js';
import { clearMediaClipboardEntry } from '../utils/mediaClipboard.js';
import { normalizeTopMessages, resolveTopMessageSyncState } from '../utils/topMessageState.js';
import { isUnavailableGroup } from '../utils/groupAvailability.js';
import { isTenantEndpointError, resolveTenantErrorMessage } from '../utils/tenantErrorMessage';
import { preloadWorkspaceRouteViews } from '../router/lazyViews.js';

const AppUpdateDialog = () => import(/* webpackChunkName: "home-overlays" */ '../components/common/AppUpdateDialog.vue');
const UserInfo = () => import(/* webpackChunkName: "home-overlays" */ '../components/common/UserInfo.vue');
const GroupInfo = () => import(/* webpackChunkName: "home-overlays" */ '../components/group/GroupInfo.vue');
const UserProfileCard = () => import(/* webpackChunkName: "home-overlays" */ '../components/common/UserProfileCard.vue');
const SettingsPanel = () => import(/* webpackChunkName: "home-overlays" */ '../components/setting/SettingsPanel.vue');
const RECENT_SESSION_RESTORE_LIMIT = 200;
const RECENT_CHAT_FIRST_PAGE_LIMIT = 200;
const RECENT_CHAT_PAGE_LIMIT = 200;
const RECENT_CHAT_MAX_PAGE_LIMIT = 200;
const RECENT_CHAT_RESTORE_RETRY_COOLDOWN_MS = 2500;

function toNumber(value, fallback = 0) {
	const num = Number(value);
	return Number.isFinite(num) ? num : fallback;
}

function normalizeRecentChatPagePayload(payload) {
	const normalized = payload && typeof payload === 'object' ? payload : {};
	const items = Array.isArray(normalized.items) ? normalized.items : [];
	const total = Math.floor(toNumber(normalized.total, 0));
	return {
		items,
		more: Boolean(normalized.more),
		total: total > 0 ? total : 0,
		cursor: normalized.cursor ? String(normalized.cursor) : ''
	};
}

function parseReceiptCursor(message) {
	try {
		const content = typeof message.content === 'string' ? JSON.parse(message.content) : message.content;
		const cursor = Number(content && content.id);
		return Number.isFinite(cursor) && cursor > 0 ? cursor : 0;
	} catch (error) {
		console.warn('已读回执内容无效', message && message.content, error);
		return 0;
	}
}

function normalizeDisplayText(value) {
	return String(value ?? '').trim();
}

function isUsableGroupDisplayName(value) {
	const text = normalizeDisplayText(value);
	return Boolean(text);
}

function pickGroupDisplayName(...values) {
	for (const value of values) {
		const text = normalizeDisplayText(value);
		if (isUsableGroupDisplayName(text)) {
			return text;
		}
	}
	return '';
}

export default {
	components: {
		AppUpdateDialog,
		HeadImage,
		UserInfo,
		GroupInfo,
		FullImage,
		FullVideo,
		RtcPrivateVideo,
		RtcGroupVideo,
		UserProfileCard,
		PreviewFile,
		SettingsPanel
	},
	data() {
		return {
			audio: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			exiting: false,
			settingsVisible: false,
			dismissDisposers: [],
			reconnecting: false,
			reconnectTimer: null,
			browserOnline: typeof navigator === 'undefined' ? true : navigator.onLine !== false,
			configRefreshTimer: null,
			workspaceRoutePreloadHandle: null,
			configRefreshIntervalMs: 5 * 60 * 1000,
			reconnectAttempts: 0,
			localCacheCleanupPending: false,
			notification: null,
			notificationRequestId: 0,
			recentSessionsRestored: false,
			recentSessionsPrimed: false,
			restoringRecentSessions: false,
			recentSessionRestorePromise: null,
			recentSessionRestoreCache: [],
			recentSessionPage: {
				cursor: '',
				more: false,
				total: 0
			},
			recentSessionPaginationPrimed: false,
			recentSessionRestoreLastFailureAt: 0,
			recentSessionBackgroundPromise: null,
			recentSessionPaginationPrimePromise: null,
			recentSessionRestoreDepsReady: false,
			deferredStoreRefreshPromise: null,
			initStages: {},
			privateMessagesBuffer: [],
			groupMessagesBuffer: [],
			systemMessagesBuffer: []
		}
	},
	methods: {
		scheduleWorkspaceRoutePreload() {
			if (this.workspaceRoutePreloadHandle) {
				return;
			}
			const preload = () => {
				this.workspaceRoutePreloadHandle = null;
				preloadWorkspaceRouteViews().catch((error) => {
					console.warn('预加载工作区路由失败', error);
				});
			};
			if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
				this.workspaceRoutePreloadHandle = window.requestIdleCallback(preload, { timeout: 1500 });
				return;
			}
			this.workspaceRoutePreloadHandle = setTimeout(preload, 240);
		},
		cancelWorkspaceRoutePreload() {
			if (!this.workspaceRoutePreloadHandle) {
				return;
			}
			if (typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') {
				window.cancelIdleCallback(this.workspaceRoutePreloadHandle);
			} else {
				clearTimeout(this.workspaceRoutePreloadHandle);
			}
			this.workspaceRoutePreloadHandle = null;
		},
		createInitStageState() {
			return {
				startedAt: 0,
				endedAt: 0,
				duration: 0,
				status: 'idle',
				error: null
			};
		},
		recordInitStage(stageName, promise) {
			const state = this.initStages[stageName] || this.createInitStageState();
			state.startedAt = Date.now();
			state.endedAt = 0;
			state.duration = 0;
			state.status = 'running';
			state.error = null;
			this.$set(this.initStages, stageName, state);
			return Promise.resolve(promise).then((result) => {
				state.endedAt = Date.now();
				state.duration = state.endedAt - state.startedAt;
				state.status = 'success';
				return result;
			}).catch((error) => {
				state.endedAt = Date.now();
				state.duration = state.endedAt - state.startedAt;
				state.status = 'failed';
				state.error = error && (error.code || error.message) || String(error);
				throw error;
			});
		},
		waitForRefReady(refName, retryCount = 120) {
			return new Promise((resolve, reject) => {
				const poll = () => {
					if (this.exiting || this._isDestroyed || this._isBeingDestroyed) {
						reject(new Error('界面已关闭'));
						return;
					}
					const ref = this.$refs[refName];
					if (ref) {
						resolve(ref);
						return;
					}
					if (retryCount <= 0) {
						reject(new Error(`${refName} 未完成挂载`));
						return;
					}
					retryCount -= 1;
					this.$nextTick(() => {
						setTimeout(poll, 16);
					});
				};
				poll();
			});
		},
		openOverlayRef(refName, args = [], errorMessage = '界面加载失败，请稍后重试') {
			if (this.exiting || this._isDestroyed || this._isBeingDestroyed) return Promise.resolve();
			return this.waitForRefReady(refName).then((ref) => {
				if (this.exiting || this._isDestroyed || this._isBeingDestroyed) return;
				if (!ref || typeof ref.open !== 'function') {
					throw new Error(`${refName} 不支持 open 调用`);
				}
				return ref.open(...args);
			}).catch((error) => {
				if (this.exiting || this._isDestroyed || this._isBeingDestroyed) return;
				console.error(`${refName} open failed`, error);
				this.$message.error(errorMessage);
			});
		},
		setConnectionState(phase, hint = '') {
			this.configStore.setConnectionState(phase, hint);
		},
		isBrowserOnline() {
			if (typeof navigator === 'undefined') {
				return true;
			}
			return navigator.onLine !== false;
		},
		onBrowserOffline() {
			this.browserOnline = false;
			if (this.exiting || !this.reconnecting) {
				return;
			}
			this.setConnectionState('RECONNECTING', '网络已断开，等待网络恢复后重试');
		},
		onBrowserOnline() {
			this.browserOnline = true;
			if (this.exiting || !this.reconnecting) {
				return;
			}
			this.clearReconnectTimer();
			this.scheduleReconnect('网络已恢复，正在尝试重连', 120);
		},
		flushPendingStorageOnPageLifecycle() {
			if (this.exiting || !this.chatStore || typeof this.chatStore.flushPersistence !== 'function') {
				return;
			}
			this.chatStore.flushPersistence().catch((error) => {
				console.warn('页面生命周期落盘失败', error);
			});
		},
		redirectToTenantEntry() {
			const fullPath = this.$route && typeof this.$route.fullPath === 'string'
				&& this.$route.fullPath.startsWith('/')
				? this.$route.fullPath
				: '/home/chat';
			const query = fullPath && !fullPath.startsWith('/tenant') ? { redirect: fullPath } : {};
			this.configStore.setAppInit(false);
			this.configStore.setWorkspaceReady(false);
			this.$router.replace({
				path: '/tenant',
				query
			}).catch((error) => {
				if (!error || error.name !== 'NavigationDuplicated') {
					console.warn('跳转租户入口失败', error);
				}
			});
		},
		isFatalReconnectError(error) {
			const code = error && error.code !== undefined ? String(error.code) : '';
			const status = Number(error && (error.status || (error.response && error.response.status) || error.code));
			const message = error && error.message ? String(error.message) : (typeof error === 'string' ? error : '');
			if (['TENANT_NOT_AVAILABLE', 'TENANT_SESSION_MISSING', 'TENANT_ENDPOINT_MISSING'].includes(code)) {
				return true;
			}
			if (status === 400 || status === 401) {
				return true;
			}
			return /重新登录|已注销|被封禁/.test(message);
		},
		handleReconnectFailure(error, delay = 5000) {
			if (this.exiting) {
				return;
			}
			if (this.isFatalReconnectError(error)) {
				const message = isTenantEndpointError(error)
					? resolveTenantErrorMessage(error, 'runtime')
					: (error && error.message ? error.message : '登录状态已失效，请重新登录');
				this.$message.error(message);
				this.onExit();
				return;
			}
			this.scheduleReconnect(this.buildReconnectHint(error), delay);
		},
		clearReconnectTimer() {
			if (this.reconnectTimer) {
				clearTimeout(this.reconnectTimer);
				this.reconnectTimer = null;
			}
		},
		startConfigRefreshLoop() {
			this.stopConfigRefreshLoop();
			this.configRefreshTimer = setInterval(() => {
				this.configStore.loadConfig({ force: true }).then(() => {
					this.ensureTenantAvailableOrExit();
				}).catch((error) => {
					console.error('周期刷新应用配置失败', error);
				});
			}, this.configRefreshIntervalMs);
		},
		stopConfigRefreshLoop() {
			if (this.configRefreshTimer) {
				clearInterval(this.configRefreshTimer);
				this.configRefreshTimer = null;
			}
		},
		ensureTenantAvailableOrExit(options = {}) {
			if (this.configStore.globalConfig && this.configStore.globalConfig.tenant
				&& this.configStore.globalConfig.tenant.available === false) {
				if (!options.silent) {
					this.$message.error('当前租户不可用，请联系管理员');
				}
				this.onExit();
				return false;
			}
			return true;
		},
		resetReconnectState() {
			this.reconnecting = false;
			this.reconnectAttempts = 0;
			this.clearReconnectTimer();
			this.configStore.setConnectionRetryCount(0);
		},
		buildReconnectHint(error) {
			if (isTenantEndpointError(error)) {
				return resolveTenantErrorMessage(error, 'reconnect');
			}
			const message = error && error.message ? String(error.message).trim() : '';
			if (!message) {
				return '网络暂不可用，正在后台重试，可继续浏览本地会话';
			}
			if (/租户/.test(message)) {
				return `${message}，正在后台重试`;
			}
			return `${message}，正在后台重试`;
		},
		formatNavBadgeCount(count) {
			if (count > 99) {
				return '99+';
			}
			return count;
		},
		scheduleReconnect(hint = '连接已断开，正在后台重试，可继续浏览本地会话', delay = 2000) {
			if (this.exiting) {
				return;
			}
			const firstReconnect = !this.reconnecting;
			this.reconnecting = true;
			if (firstReconnect) {
				this.$message.warning(hint);
			}
			if (this.reconnectTimer) {
				this.setConnectionState('RECONNECTING', hint);
				return;
			}
			this.reconnectAttempts += 1;
			this.configStore.setConnectionRetryCount(this.reconnectAttempts);
			this.setConnectionState('RECONNECTING', hint);
			this.reconnectTimer = setTimeout(() => {
				this.reconnectTimer = null;
				this.reconnectWs();
			}, delay);
		},
		flushBufferedMessages() {
			this.privateMessagesBuffer.forEach((m) => this.handlePrivateMessage(m));
			this.groupMessagesBuffer.forEach((m) => this.handleGroupMessage(m));
			this.systemMessagesBuffer.forEach((m) => this.handleSystemMessageDispatch(m));
			this.privateMessagesBuffer = [];
			this.groupMessagesBuffer = [];
			this.systemMessagesBuffer = [];
		},
		async clearLocalCacheSilently() {
			if (this.localCacheCleanupPending) {
				return;
			}
			this.localCacheCleanupPending = true;
			try {
				await Promise.all([
					this.chatStore.clearPersistedStorage(),
					clearMediaClipboardEntry()
				]);
			} finally {
				this.localCacheCleanupPending = false;
			}
		},
		onSettingsClearLocalCache(controls = {}) {
			const { resolve, reject } = controls;
			this.clearLocalCacheSilently().then(() => {
				if (typeof resolve === 'function') {
					resolve();
				}
			}).catch((error) => {
				if (typeof reject === 'function') {
					reject(error);
				}
			});
		},
		unbindWorkspaceEvents() {
			Object.entries(this.workspaceEventHandlers || {}).forEach(([event, handler]) => {
				this.$eventBus.$off(event, handler);
			});
			this.workspaceEventHandlers = null;
		},
		init() {
			this.unbindWorkspaceEvents();
			const handlers = this.workspaceEventHandlers = {};
			const bind = (event, handler) => {
				handlers[event] = handler;
				this.$eventBus.$on(event, handler);
			};
			bind('exit', () => {
				// 退出登陆
				this.onExit();
			});
			bind('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			bind('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$refs.rtcGroupVideo.open(rctInfo);
			});
			bind('openUserInfo', (user, pos) => {
				// 打开用户卡片
				this.openOverlayRef('userInfo', [user, pos], '用户资料面板加载失败，请刷新重试');
			});
			bind('openGroupInfo', (group, token, pos) => {
				// 打开群卡片
				this.openOverlayRef('groupInfo', [group, token, pos], '群资料面板加载失败，请刷新重试');
			});
			bind('openFullImage', url => {
				// 图片大图
				this.openOverlayRef('fullImage', [url], '图片预览加载失败，请稍后重试');
			});
			bind('openFullVideo', payload => {
				// 视频大图
				this.openOverlayRef('fullVideo', [payload], '视频预览加载失败，请稍后重试');
			});
			bind('openPreviewFile', url => {
				// 文件预览
				this.openOverlayRef('previewFile', [url], '文件预览加载失败，请稍后重试');
			});
			this.configStore.setAppInit(false)
			this.configStore.setWorkspaceReady(false);
			this.setConnectionState('CONNECTING', '正在初始化应用');
			Promise.resolve().then(() => {
				const session = this.$tenantEndpoint.getCurrentSession();
				if (!session) {
					this.redirectToTenantEntry();
					throw new Error('TENANT_NOT_READY');
				}
				return this.loadStore();
			}).then(() => {
				this.configStore.setWorkspaceReady(true);
				this.deferredStoreRefreshPromise = this.refreshDeferredStores();
				let wsUrl = '';
				try {
					wsUrl = this.$tenantEndpoint.getWsUrl();
				} catch (error) {
					this.redirectToTenantEntry();
					return;
				}
				this.$wsApi.onConnect(() => {
					this.$tenantEndpoint.resetFailureState();
					this.clearReconnectTimer();
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						void this.syncOfflineMessages().catch((error) => {
							console.error('首次消息同步失败', error);
						});
						this.$desktopUpdater.autoCheckForCurrentTenant();
					}
				});
				this.$wsApi.onMessage((cmd, msgInfo) => {
					if (cmd == 2) {
						// 关闭ws
						this.$wsApi.close(3000)
						// 异地登录，强制下线
						this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
							confirmButtonText: '确定',
							callback: action => {
								this.onExit();
							}
						});
					} else if (cmd == 3) {
						if (!this.configStore.appInit || this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.privateMessagesBuffer.push(msgInfo);
						} else {
							// 插入私聊消息
							this.handlePrivateMessage(msgInfo);
						}
					} else if (cmd == 4) {
						if (!this.configStore.appInit || this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							console.log("消息进入缓存区:", msgInfo)
							this.groupMessagesBuffer.push(msgInfo);
						} else {
							// 插入群聊消息
							this.handleGroupMessage(msgInfo);
						}
					} else if (cmd == 5) {
						if (!this.configStore.appInit || this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.systemMessagesBuffer.push(msgInfo);
						} else {
							// 处理系统消息（根据 msgInfo.type 判断具体类型）
							this.handleSystemMessageDispatch(msgInfo);
						}
					}
				});
				this.$wsApi.onClose(e => {
					console.log(e);
					if (e.code != 3000) {
						this.configStore.setAppInit(false)
						this.chatStore.setLoading(false);
						// 断线重连（必要时切换线路）
						this.$tenantEndpoint.reRaceOnConnectionFailure().then((switched) => {
							if (switched) {
								this.scheduleReconnect('当前线路不可用，已自动切换线路并继续重连', 600);
								return;
							}
							this.scheduleReconnect();
						}).catch((error) => {
							console.log(error);
							this.handleReconnectFailure(error, 5000);
						})
					}
				});
				// ws初始化
				this.$wsApi.connect(wsUrl, sessionStorage.getItem("accessToken"));
			}).catch(e => {
				if (e && e.message === 'TENANT_NOT_READY') {
					return;
				}
				if (e && e.code === 'TENANT_UNAVAILABLE_EXITED') {
					return;
				}
				console.log(e)
				this.handleReconnectFailure(e, 3000);
			})
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			if (!this.isBrowserOnline()) {
				this.browserOnline = false;
				this.setConnectionState('RECONNECTING', '网络已断开，等待网络恢复后重试');
				this.scheduleReconnect('网络已断开，等待网络恢复后重试', 5000);
				return;
			}
			this.browserOnline = true;
			this.setConnectionState('RECONNECTING', `连接已断开，正在第${this.reconnectAttempts || 1}次重试`);
			const session = this.$tenantEndpoint.getCurrentSession();
			if (!session) {
				this.redirectToTenantEntry();
				return;
			}
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.userStore.loadUser().then(() => {
				this.setConnectionState('CONNECTING', '正在重新连接服务器');
				this.$wsApi.connect(this.$tenantEndpoint.getWsUrl(), sessionStorage.getItem(
					"accessToken"));
			}).catch((error) => {
				console.log(error);
				this.handleReconnectFailure(error, 10000);
			});
		},
			onReconnectWs() {
				// 重新加载群和好友
				const promises = [];
				promises.push(this.friendStore.loadFriend());
				promises.push(this.friendGroupStore.loadGroups({
					forceReload: true,
					limit: 30
				}));
			promises.push(this.groupStore.loadGroup());
			Promise.allSettled(promises).then(async (results) => {
				const hasFatalRejected = results.some((result) => result.status === 'rejected'
					&& !(result.reason && result.reason.code === 'TENANT_UNAVAILABLE_EXITED'));
				if (hasFatalRejected) {
					const firstRejected = results.find((result) => result.status === 'rejected');
					throw (firstRejected && firstRejected.reason) || new Error('RECONNECT_SYNC_FAILED');
				}
				this.reconcileUnavailableGroupChats();
				this.recentSessionRestoreDepsReady = true;
				this.resetReconnectState();
				this.setConnectionState('SYNCING', '已恢复连接，正在同步最近消息');
				await this.syncOfflineMessages();
				this.startConfigRefreshLoop();
				this.$desktopUpdater.autoCheckForCurrentTenant();
				this.$message.success("重新连接成功");
			}).catch((error) => {
				console.log(error);
				this.handleReconnectFailure(error, 5000);
			})
		},
		loadStore() {
			this.recentSessionsRestored = false;
			this.recentSessionsPrimed = false;
			this.restoringRecentSessions = false;
			this.recentSessionRestorePromise = null;
			this.recentSessionRestoreCache = [];
			this.recentSessionPage = {
				cursor: '',
				more: false,
				total: 0
			};
			this.recentSessionPaginationPrimed = false;
			this.recentSessionRestoreLastFailureAt = 0;
			this.recentSessionBackgroundPromise = null;
			this.recentSessionPaginationPrimePromise = null;
			this.recentSessionRestoreDepsReady = false;
			this.deferredStoreRefreshPromise = null;
			this.initStages = {};
			return this.userStore.loadUser().then(() => {
				const userId = this.userStore.userInfo && this.userStore.userInfo.id;
				if (userId === undefined || userId === null || userId === '') {
					const error = new Error('USER_ID_MISSING');
					error.code = 'USER_ID_MISSING';
					throw error;
				}
				return Promise.resolve(this.$db.open(userId)).then(() => {
					return this.chatStore.loadChat().then((result) => {
						if (!this.ensureTenantAvailableOrExit()) {
							const error = new Error('TENANT_UNAVAILABLE_EXITED');
							error.code = 'TENANT_UNAVAILABLE_EXITED';
							throw error;
						}
						return result;
					});
				});
			})
		},
		refreshDeferredStores() {
			this.recentSessionRestoreDepsReady = false;
			const friendsRemote = this.recordInitStage('friends', this.friendStore.loadFriend().then(() => {
				this.chatStore.refreshChats();
			}));
			const friendGroupsRemote = this.recordInitStage('friendGroups', this.friendGroupStore.loadGroups({
				forceReload: true,
				limit: 30
			}));
			const groupsRemote = this.recordInitStage('groups', this.groupStore.loadGroup().then(() => {
				this.reconcileUnavailableGroupChats();
				this.reconcileGroupMessageClears();
				this.chatStore.refreshChats();
				void this.restoreRecentSessionsIfNeeded({
					forceReplay: true
				});
			}));
			const configRemote = this.recordInitStage('config', this.configStore.loadConfig().then(() => {
				if (!this.ensureTenantAvailableOrExit()) {
					const error = new Error('TENANT_UNAVAILABLE_EXITED');
					error.code = 'TENANT_UNAVAILABLE_EXITED';
					throw error;
				}
			}));
			const permissionsRemote = this.recordInitStage('permissions', this.userStore.loadPermissions());
			const remoteTasks = [friendsRemote, friendGroupsRemote, groupsRemote, configRemote, permissionsRemote];
			// L2（最近会话恢复）等本地恢复完成即可放行；远端段在后台继续。
			const localReadyTasks = [
				this.recordInitStage('friends.local', this.friendStore.loadFriendLocalReady()),
				this.recordInitStage('friendGroups.local', this.friendGroupStore.loadGroupsLocalReady()),
				this.recordInitStage('groups.local', this.groupStore.loadGroupLocalReady()),
				configRemote,
				permissionsRemote
			];
			const localReadyGate = Promise.all(localReadyTasks).then(() => {
				this.reconcileUnavailableGroupChats();
				this.recentSessionRestoreDepsReady = true;
				if (this.configStore.appInit) {
					void this.restoreRecentSessionsIfNeeded();
				}
			}).catch((error) => {
				this.recentSessionRestoreDepsReady = false;
				if (!(error && error.code === 'TENANT_UNAVAILABLE_EXITED')) {
					console.error('刷新基础数据本地恢复阶段失败，最近会话恢复保持阻断', error);
				}
				throw error;
			});
			// 维持原返回语义：调用方拿到的 promise 仍代表"远端段全部完成"，但 L2 已在 localReadyGate 后被放行。
			const remoteGate = Promise.all(remoteTasks).catch((error) => {
				if (!(error && error.code === 'TENANT_UNAVAILABLE_EXITED')) {
					console.error('刷新基础数据远端段失败', error);
				}
				throw error;
			});
			return localReadyGate.then(() => remoteGate);
		},
		unloadStore() {
			this.friendStore.clear();
			this.friendGroupStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
			this.recentSessionsRestored = false;
			this.recentSessionsPrimed = false;
			this.restoringRecentSessions = false;
			this.recentSessionRestorePromise = null;
			this.recentSessionRestoreCache = [];
			this.recentSessionPage = {
				cursor: '',
				more: false,
				total: 0
			};
			this.recentSessionPaginationPrimed = false;
			this.recentSessionRestoreLastFailureAt = 0;
			this.recentSessionBackgroundPromise = null;
			this.recentSessionPaginationPrimePromise = null;
			this.recentSessionRestoreDepsReady = false;
			this.deferredStoreRefreshPromise = null;
			this.initStages = {};
		},
		toTimestamp(value) {
			if (value === undefined || value === null || value === '') {
				return 0;
			}
			if (typeof value === 'number') {
				return Number.isFinite(value) ? value : 0;
			}
			const num = Number(value);
			if (Number.isFinite(num) && num > 0) {
				return num;
			}
			const time = new Date(value).getTime();
			return Number.isFinite(time) ? time : 0;
		},
			syncGroupTopMessages(groupId, options = {}) {
				if (!groupId) {
					return;
				}
				const {
					expectedCount,
					expectedLatestId,
					retryTimes = 0,
					retryDelay = 320
				} = options;
				this.$http({
					url: `/group/find/${groupId}`,
					method: 'get'
				}).then((groupInfo) => {
					const localGroup = this.groupStore.findGroup(groupId);
					const resolvedTopState = resolveTopMessageSyncState({
						localTopMessages: localGroup && localGroup.topMessages,
						incomingTopMessages: groupInfo.topMessages,
						expectedTopCount: expectedCount,
						expectedLatestId,
						preserveOnMismatch: retryTimes > 0
					});
					groupInfo.topMessages = resolvedTopState.topMessages;
					this.groupStore.upsertGroup(groupInfo);
					if (!resolvedTopState.matched && retryTimes > 0) {
						setTimeout(() => {
							this.syncGroupTopMessages(groupId, {
								expectedCount,
								expectedLatestId,
								retryTimes: retryTimes - 1,
								retryDelay
							});
						}, retryDelay);
					}
				}).catch(() => {
					if (retryTimes > 0) {
						setTimeout(() => {
							this.syncGroupTopMessages(groupId, {
								expectedCount,
								expectedLatestId,
								retryTimes: retryTimes - 1,
								retryDelay
							});
						}, retryDelay);
					}
				});
			},
		reconcileUnavailableGroupChats() {
			const groups = Array.isArray(this.groupStore.groups) ? this.groupStore.groups : [];
			let removedCount = 0;
			groups.forEach((group) => {
				if (!group || !group.id || !isUnavailableGroup(group)) {
					return;
				}
				const chat = this.chatStore.findChat({
					type: 'GROUP',
					targetId: group.id
				});
				if (!chat) {
					return;
				}
				this.chatStore.removeGroupChat(group.id);
				removedCount++;
			});
			return removedCount;
		},
		reconcileGroupMessageClears() {
			const groups = Array.isArray(this.groupStore.groups) ? this.groupStore.groups : [];
				if (groups.length === 0) {
					return;
				}
				groups.forEach((group) => {
					if (!group || !group.id) {
						return;
					}
					const clearTs = this.toTimestamp(group.messageClearTime);
					if (clearTs <= 0) {
						return;
					}
					const chatInfo = {
						type: 'GROUP',
						targetId: group.id
					};
					const chat = this.chatStore.findChat(chatInfo);
					if (!chat || !Array.isArray(chat.messages) || chat.messages.length === 0) {
						return;
					}
					const hasNewerMessage = chat.messages.some((m) => {
						if (!m || m.type == this.$enums.MESSAGE_TYPE.TIP_TIME) {
							return false;
						}
						return this.toTimestamp(m.sendTime) > clearTs;
					});
					if (!hasNewerMessage) {
						this.chatStore.cleanMessage(chatInfo);
					}
				});
			},
			processOfflineMessageTask(name, stream, url, after, handler) {
				return this.syncMessageStream(stream, url, after, handler).then((count) => ({
					name,
					count,
					success: true
				})).catch((error) => {
					console.warn(`加载${name}离线消息失败`, error);
					return {
						name,
						count: 0,
						success: false,
						error
					};
				});
			},
			waitForRecentSessionsBeforeLeavingLoading() {
				const restoreSessions = () => this.restoreRecentSessionsIfNeeded({
					allowWithoutDeps: false,
					refreshCache: false
				}).catch((error) => {
					console.warn('恢复最近会话摘要失败', error);
					return 0;
				}).then(() => this.ensureRecentChatsFullyLoaded());
				if (this.recentSessionRestoreDepsReady) {
					return restoreSessions();
				}
				if (!this.deferredStoreRefreshPromise) {
					return Promise.resolve(0);
				}
				return Promise.resolve(this.deferredStoreRefreshPromise)
					.catch((error) => {
						console.warn('等待最近会话恢复依赖失败', error);
						return 0;
					})
					.then(() => this.recentSessionRestoreDepsReady ? restoreSessions() : 0);
			},
			async syncOfflineMessages() {
				let timeStamp = new Date().getTime();
				this.reconcileGroupMessageClears();
				this.chatStore.setLoading(true);
				this.setConnectionState('SYNCING', '正在同步最近消息');
				try {
					await this.syncConversationStates();
				} catch (error) {
					console.warn('同步会话状态失败，保留本地快照', error);
				}
				const tasks = [
					this.processOfflineMessageTask('私聊', 'private', '/message/private/loadOfflineMessage',
						this.chatStore.privateMsgMaxId, (message) => this.handlePrivateMessage(message)),
					this.processOfflineMessageTask('群聊', 'group', '/message/group/loadOfflineMessage',
						this.chatStore.groupMsgMaxId, (message) => this.handleGroupMessage(message)),
					this.processOfflineMessageTask('系统', 'system', '/message/system/loadOfflineMessage',
						this.chatStore.systemMsgMaxSeqNo, (message) => this.handleSystemMessage(message))
				];
				let results = [];
				try {
					results = await Promise.all(tasks);
					await this.waitForRecentSessionsBeforeLeavingLoading();
				} finally {
					this.flushBufferedMessages();
					try {
						await this.chatStore.flushPersistence();
					} finally {
						this.chatStore.setLoading(false);
						this.chatStore.refreshChats();
					}
				}
				this.configStore.setAppInit(true);
				if (this.recentSessionRestoreDepsReady) {
					void this.restoreRecentSessionsIfNeeded();
				}
				this.setConnectionState('CONNECTED', '');
				this.configStore.setConnectionRetryCount(0);
				const size = results.reduce((sum, item) => sum + item.count, 0);
				console.log("同步离线消息耗时:", new Date().getTime() - timeStamp, ",消息数量:", size)
				if (results.some(item => !item.success)) {
					this.$message.warning("部分离线消息同步失败，已保留本地会话");
				}
				return results;
			},
			async syncConversationStates() {
				const states = [];
				const visitedCursors = new Set();
				let cursor = '';
				do {
					const params = new URLSearchParams();
					params.set('limit', '200');
					if (cursor) params.set('cursor', cursor);
					const page = await this.$http({
						url: `/message/conversationStates?${params.toString()}`,
						method: 'get'
					});
					if (!page || !Array.isArray(page.items) || typeof page.more !== 'boolean' ||
						(page.more && !page.cursor) || (!page.more && page.cursor)) {
						throw new Error('会话状态响应不符合 Page 契约');
					}
					states.push(...page.items);
					if (!page.more) break;
					cursor = String(page.cursor);
					if (visitedCursors.has(cursor)) throw new Error('会话状态分页游标重复');
					visitedCursors.add(cursor);
				} while (cursor);
				this.chatStore.replaceConversationStates(states);
				await this.restorePinnedConversationShells(states);
				await this.chatStore.flushPersistence();
				return states.length;
			},
			async restorePinnedConversationShells(states) {
				const pinnedStates = (Array.isArray(states) ? states : []).filter((state) =>
					state && state.isTop === true && (state.type === 'PRIVATE' || state.type === 'GROUP') &&
					!this.chatStore.findChat({ type: state.type, targetId: state.targetId }));
				await Promise.all(pinnedStates.map(async (state) => {
					try {
						if (state.type === 'PRIVATE') {
							let friend = this.friendStore.findFriend(state.targetId);
							if (friend && friend.deleted) return;
							if (!friend) {
								friend = await this.$http({
									url: `/friend/find/${state.targetId}`,
									method: 'get'
								});
								if (!friend || friend.deleted) return;
								await this.friendStore.addFriend(friend);
							}
							this.chatStore.restoreChatShell({
								type: 'PRIVATE',
								targetId: state.targetId,
								showName: resolvePrivateDisplayName(friend) || friend.showNickName || friend.nickName || friend.userName || '',
								headImage: friend.headImage || '',
								userName: friend.userName || ''
							});
							return;
						}
						let group = this.groupStore.findGroup(state.targetId);
						if (!group) {
							group = await this.$http({
								url: `/group/find/${state.targetId}`,
								method: 'get'
							});
							if (!group || group.quit || group.dissolve) return;
							this.groupStore.addGroup(group);
						}
						if (!group.quit && !group.dissolve) {
							this.chatStore.restoreChatShell({
								type: 'GROUP',
								targetId: state.targetId,
								showName: resolveGroupChatDisplayName(group) || group.remarkGroupName || group.name || '',
								headImage: group.headImageThumb || group.headImage || ''
							});
						}
					} catch (error) {
						console.warn('置顶会话壳恢复失败，已跳过', state, error);
					}
				}));
			},
		async syncMessageStream(stream, url, after, handler) {
			const base = Math.max(0, Number(after) || 0);
			let cursor = '';
			let watermark = null;
			let count = 0;
			const visitedCursors = new Set();
			do {
				const query = [`after=${base}`, 'limit=200'];
				if (cursor) {
					query.push(`cursor=${encodeURIComponent(cursor)}`);
				}
				const page = await this.$http({
					url: `${url}?${query.join('&')}`,
					method: 'GET'
				});
				const pageWatermark = Number(page && page.watermark);
				if (!page || !Array.isArray(page.items) || typeof page.more !== 'boolean' ||
					!Number.isFinite(pageWatermark) || pageWatermark < base ||
					(page.more && !page.cursor) || (!page.more && page.cursor)) {
					throw new Error(`${stream} 离线消息响应不符合 MessagePage 契约`);
				}
				if (watermark !== null && watermark !== pageWatermark) {
					throw new Error(`${stream} 离线消息同步水位发生变化`);
				}
				watermark = pageWatermark;
				page.items.forEach(handler);
				count += page.items.length;
				await this.chatStore.flushPersistence();
				if (!page.more) {
					break;
				}
				cursor = String(page.cursor);
				if (visitedCursors.has(cursor)) {
					throw new Error(`${stream} 离线消息游标重复`);
				}
				visitedCursors.add(cursor);
			} while (cursor);
			this.chatStore.advanceSyncCursor(stream, watermark === null ? base : watermark);
			await this.chatStore.flushPersistence();
			return count;
		},
		handlePrivateMessage(msg) {
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.mine.id;
			// 好友id
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			// 会话信息
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friendId
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount(chatInfo)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				const maxId = parseReceiptCursor(msg);
				if (!maxId) {
					return;
				}
				this.chatStore.readedMessage({
					friendId: msg.sendId,
					maxId
				})
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			// 消息编辑
			if (msg.type == this.$enums.MESSAGE_TYPE.MESSAGE_EDITED) {
				this.chatStore.updateMessage(msg, chatInfo)
				return;
			}
			// 好友申请
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
				this.friendStore.addRequest(JSON.parse(msg.content))
				return;
			}
			// 好友申请被同意、拒绝、撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL) {
				this.friendStore.removeRequest(JSON.parse(msg.content).id)
				return;
			}
			// 新增好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(msg.content));
				return;
			}
			// 删除好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				this.friendGroupStore.removeFriend(friendId);
				return;
			}
			// 好友在线状态
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				this.friendStore.updateOnlineStatus(JSON.parse(msg.content));
				return;
			}
			// 对好友设置免打扰
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 对好友进行会话置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_TOP) {
				this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(msg.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(msg)
				return;
			}
			// 消息插入
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let friend = this.loadFriendInfo(friendId);
				this.insertPrivateMessage(friend, msg);
			}
		},
		insertPrivateMessage(friend, msg) {
			const targetId = friend && friend.id;
			const existingChat = targetId
				? this.chatStore.findChat({
					type: 'PRIVATE',
					targetId
				})
				: null;
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: resolvePrivateDisplayName(friend) || (existingChat && existingChat.showName) || '',
				headImage: friend.headImage,
				userName: friend.userName || ''
			};
			// 打开会话
			this.chatStore.openChat(chatInfo);
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo);
			const chat = this.chatStore.findChat(chatInfo);
			if (chat && !this.chatStore.isDnd(chat) && !this.chatStore.loading &&
				!msg.selfSend && this.$msgType.isNormal(msg.type)
				&& msg.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				this.showNotification(chat, friend.showNickName, friend.headImage)
			}
		},
		handleGroupMessage(msg) {
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.mine.id;
			// 发送用户昵称优先显示好友备注的名字
			if (msg.sendId && msg.sendNickName) {
				let f = this.friendStore.findFriend(msg.sendId);
				if (f && !f.deleted && f.remarkNickName) {
					msg.sendNickName = f.remarkNickName;
				}
			}
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId
			}
			// 消息已读处理
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				this.chatStore.resetUnreadCount(chatInfo)
				this.chatStore.resetAtMessage(chatInfo)
				return;
			}
			// 消息回执处理
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.chatStore.updateMessage(msgInfo, chatInfo)
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			// 消息编辑
			if (msg.type == this.$enums.MESSAGE_TYPE.MESSAGE_EDITED) {
				this.chatStore.updateMessage(msg, chatInfo)
				return;
			}
				// 新增群
				if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
					const group = JSON.parse(msg.content);
					this.groupStore.addGroup(group);
					this.openNewGroupChat(group, msg.sendTime);
					return;
				}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_INFO_CHANGED) {
				const groupPatch = msg.content ? JSON.parse(msg.content) : null;
				const nextGroup = this.mergeGroupInfoPatch(groupPatch);
				if (nextGroup) {
					this.groupStore.addGroup(nextGroup);
					this.chatStore.updateChatFromGroup(nextGroup);
				}
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MESSAGE_CLEARED) {
				this.chatStore.clearRemovedMemberMessages(msg, chatInfo);
				this.groupStore.clearRemovedMemberMessages(msg.groupId, msg.content);
				return;
			}
			// 删除群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.groupStore.removeGroup(msg.groupId);
				this.chatStore.removeGroupChat(msg.groupId);
				return;
			}
			// 群消息置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
				let latestTopMessage = msg.content ? JSON.parse(msg.content) : null;
				const group = this.groupStore.findGroup(msg.groupId);
				const previousTopMessages = normalizeTopMessages(group && group.topMessages);
				const previousCount = previousTopMessages.length;
				const expectedLatestId = latestTopMessage ? latestTopMessage.id : '';
				const expectedCount = latestTopMessage
					? (previousTopMessages.some((item) => item && item.id == latestTopMessage.id)
						? Math.max(previousCount - 1, 0)
						: previousCount + 1)
					: 0;
				// 先同步本地最新置顶状态，避免刷新失败或接口未返回 topMessages 时 UI 长时间停留在旧状态。
				this.groupStore.updateTopMessage(msg.groupId, latestTopMessage);
				this.syncGroupTopMessages(msg.groupId, {
					expectedCount,
					expectedLatestId,
					retryTimes: 2
				});
				return;
			}
			// 对群设置免打扰
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 群全体禁言
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_ALL_MUTED) {
				this.groupStore.setAllMuted(msg.groupId, JSON.parse(msg.content));
				return;
			}
			// 群成员禁言状态变更
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MUTED) {
				const payload = JSON.parse(msg.content);
				if (payload && typeof payload === 'object' && Array.isArray(payload.userIds)) {
					this.groupStore.setGroupMembersMuted(msg.groupId, payload.userIds, payload.isMuted);
				} else {
					this.groupStore.refreshMember(msg.groupId, {
						forceRefresh: true,
						refreshOnline: false,
						pageLimit: 30
					});
				}
				return;
			}
			// 群成员变更
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_CHANGED) {
				let payload = null;
				try {
					payload = msg.content ? JSON.parse(msg.content) : null;
				} catch (error) {
					payload = null;
				}
				if (payload && payload.memberCount !== undefined) {
					this.groupStore.applyGroupMemberCount(msg.groupId, payload.memberCount);
					const group = this.groupStore.findGroup(msg.groupId);
					if (group) {
						this.chatStore.updateChatFromGroup(group);
					}
				}
				this.groupStore.refreshMember(msg.groupId, {
					forceRefresh: true,
					refreshOnline: false,
					pageLimit: 30
				});
				return;
			}
			// 群聊消息清空（后台操作）
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MESSAGE_CLEARED) {
				// 仅清理本地已有会话的消息，避免创建“空会话”造成列表污染
				if (this.chatStore.findChat(chatInfo)) {
					this.chatStore.cleanMessage(chatInfo);
				}
				return;
			}
			// 对好友进行会话置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP) {
				this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 群通话信令
			if (this.$msgType.isRtcGroup(msg.type)) {
				if (msg.type == this.$enums.MESSAGE_TYPE.RTC_GROUP_INFO) {
					// 群通话状态变化
					const rtcInfo = JSON.parse(msg.content);
					this.groupStore.setRtcInfo(msg.groupId, rtcInfo);
					// 通话窗口打开时同步实际媒体入会状态，避免只更新群列表而不更新当前窗口。
					this.$nextTick(() => {
						if (this.$refs.rtcGroupVideo && this.$refs.rtcGroupVideo.onRTCMessage) {
							this.$refs.rtcGroupVideo.onRTCMessage(msg);
						}
					});
				} else {
					this.$nextTick(() => {
						this.$refs.rtcGroupVideo.onRTCMessage(msg);
					})
				}
				return;
			}
			// 插入群聊消息
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.insertGroupMessage(group, msg);
			}
		},
		insertGroupMessage(group, msg) {
			const targetId = (group && group.id) || (msg && msg.groupId);
			if (!targetId) {
				return;
			}
			const chatKey = {
				type: 'GROUP',
				targetId
			};
			const existingChat = this.chatStore.findChat(chatKey);
			const recentChat = this.findRecentGroupChatSummary(targetId);
			const groupDisplayName = this.resolveGroupConversationDisplayName(group, recentChat, existingChat);
			const groupHeadImage = (group && (group.headImageThumb || group.headImage))
				|| (recentChat && recentChat.headImage)
				|| (existingChat && existingChat.headImage)
				|| '';
			let chatInfo = {
				type: 'GROUP',
				targetId,
				showName: groupDisplayName,
				headImage: groupHeadImage
			};
			// 打开会话
			this.chatStore.openChat(chatInfo);
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo);
			// 提示音和消息提醒
			const chat = this.chatStore.findChat(chatInfo);
			if (chat && !this.chatStore.isDnd(chat) && !msg.selfSend && !this.chatStore.loading && this.$msgType.isNormal(msg.type)
				&& msg.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				this.showNotification(chat, groupDisplayName, groupHeadImage)
			}
		},
		mergeGroupInfoPatch(patch) {
			if (!patch || !patch.id) {
				return null;
			}
			const currentGroup = this.groupStore.findGroup(patch.id) || {};
			const nextGroup = {
				...currentGroup,
				...patch
			};
			nextGroup.showGroupName = resolveGroupChatDisplayName(nextGroup) || nextGroup.name || currentGroup.showGroupName || '';
			return nextGroup;
		},
		openNewGroupChat(group, sendTime) {
			if (!group || !group.id) {
				return;
			}
			const chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				showName: this.resolveGroupConversationDisplayName(group, null, null),
				headImage: group.headImageThumb || group.headImage || ''
			};
			this.chatStore.openChat(chatInfo);
			const chat = this.chatStore.findChat(chatInfo);
			const nextTime = sendTime || Date.now();
			if (chat) {
				chat.optTime = nextTime;
				chat.lastSendTime = nextTime;
			}
			this.chatStore.refreshChats();
		},
		handleSystemMessage(msg) {
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount({
					type: 'SYSTEM',
					targetId: 0
				})
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.CONFIG_CHANGED
				|| msg.type == this.$enums.MESSAGE_TYPE.ROLE_CHANGED
				|| msg.type == this.$enums.MESSAGE_TYPE.ROLE_PERM_UPDATED
				|| msg.type == this.$enums.MESSAGE_TYPE.USER_INFO_CHANGED
				|| msg.type == this.$enums.MESSAGE_TYPE.GROUP_PERM_CHANGED) {
				this.handleSystemMessageDispatch(msg);
				return;
			}
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 用户账户注销
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已注销", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 插入消息
			this.insertSystemMessage(msg);
		},
		insertSystemMessage(msg) {
			let headImage = require('@/assets/image/chat_system.png')
			let chatInfo = {
				type: 'SYSTEM',
				targetId: 0,
				showName: "系统通知",
				headImage: headImage
			};
			// 打开会话
			this.chatStore.openChat(chatInfo);
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo);
		},
		onToggleTheme() {
			const next = this.configStore.theme === 'dark' ? 'light' : 'dark';
			this.configStore.setTheme(next);
		},
		toggleSettingsPanel() {
			this.settingsVisible = !this.settingsVisible;
		},
		closeSettingsPanel() {
			this.settingsVisible = false;
		},
		onSettingsLogout() {
			this.closeSettingsPanel();
			this.onExit();
		},
		finalizeExitCleanup() {
			this.unloadStore();
			this.configStore.setAppInit(false);
			this.configStore.setWorkspaceReady(false);
			this.configStore.resetConnectionState();
			this.$desktopUpdater.resetSession();
			this.$tenantEndpoint.resetFailureState();
		},
		onExit() {
			if (this.exiting) {
				return;
			}
			this.exiting = true;
			this.closeSettingsPanel();
			this.lastAutoUpdateVersionNotified = '';
			this.stopConfigRefreshLoop();
			this.resetReconnectState();
			this.$wsApi.close(3000);
			clearAuthSession();
			this.$router.replace("/login").catch((error) => {
				if (error && error.name !== "NavigationDuplicated") {
					console.error(error);
				}
			}).finally(() => {
				this.finalizeExitCleanup();
			});
		},
		registerDismissable(entry) {
			this.dismissDisposers.push(dismissStack.register(entry));
		},
		clearDismissableRegistrations() {
			this.dismissDisposers.forEach((dispose) => {
				if (typeof dispose === 'function') {
					dispose();
				}
			});
			this.dismissDisposers = [];
		},
		registerShellDismissables() {
			this.clearDismissableRegistrations();
			this.registerDismissable({
				id: `home-settings-panel-${this._uid}`,
				isOpen: () => this.configStore.isDesktop && Boolean(this.settingsVisible),
				getZIndex: () => resolveZIndex(this.$refs.settingsPopover && this.$refs.settingsPopover.popperElm, 2000),
				close: () => {
					this.closeSettingsPanel();
				}
			});
			this.registerDismissable({
				id: `home-user-info-${this._uid}`,
				isOpen: () => Boolean(this.$refs.userInfo && this.$refs.userInfo.show),
				getZIndex: () => resolveZIndex(this.$refs.userInfo && this.$refs.userInfo.$el, 9999),
				close: () => {
					if (this.$refs.userInfo && this.$refs.userInfo.close) {
						this.$refs.userInfo.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-group-info-${this._uid}`,
				isOpen: () => Boolean(this.$refs.groupInfo && this.$refs.groupInfo.show),
				getZIndex: () => resolveZIndex(this.$refs.groupInfo && this.$refs.groupInfo.$el, 9999),
				close: () => {
					if (this.$refs.groupInfo && this.$refs.groupInfo.close) {
						this.$refs.groupInfo.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-full-image-${this._uid}`,
				isOpen: () => Boolean(this.$refs.fullImage && this.$refs.fullImage.show),
				getZIndex: () => resolveZIndex(this.$refs.fullImage && this.$refs.fullImage.$el, 9999),
				close: () => {
					if (this.$refs.fullImage && this.$refs.fullImage.close) {
						this.$refs.fullImage.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-full-video-${this._uid}`,
				isOpen: () => Boolean(this.$refs.fullVideo && this.$refs.fullVideo.show),
				getZIndex: () => resolveZIndex(this.$refs.fullVideo && this.$refs.fullVideo.$el, 9999),
				close: () => {
					if (this.$refs.fullVideo && this.$refs.fullVideo.close) {
						this.$refs.fullVideo.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-preview-file-${this._uid}`,
				isOpen: () => Boolean(this.$refs.previewFile && this.$refs.previewFile.show),
				getZIndex: () => resolveZIndex([
					this.$refs.previewFile && this.$refs.previewFile.$el,
					this.$refs.previewFile && this.$refs.previewFile.$el
						? this.$refs.previewFile.$el.querySelector('.preview-container')
						: null
				], 10000),
				close: () => {
					if (this.$refs.previewFile && this.$refs.previewFile.close) {
						this.$refs.previewFile.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-user-profile-${this._uid}`,
				isOpen: () => Boolean(this.$refs.userProfileCard && this.$refs.userProfileCard.isShow),
				getZIndex: () => resolveZIndex(this.$refs.userProfileCard && this.$refs.userProfileCard.$el, 2000),
				close: () => {
					if (this.$refs.userProfileCard && this.$refs.userProfileCard.close) {
						this.$refs.userProfileCard.close();
					}
				}
			});
			this.registerDismissable({
				id: `home-rtc-private-${this._uid}`,
				isOpen: () => Boolean(this.$refs.rtcPrivateVideo && this.$refs.rtcPrivateVideo.showRoom),
				getZIndex: () => resolveZIndex([
					this.$refs.rtcPrivateVideo && this.$refs.rtcPrivateVideo.$el
						? this.$refs.rtcPrivateVideo.$el.querySelector('.custom-dialog')
						: null,
					this.$refs.rtcPrivateVideo && this.$refs.rtcPrivateVideo.$el
						? this.$refs.rtcPrivateVideo.$el.querySelector('.taskbar-icon')
						: null
				], 999),
				close: () => {
					if (this.$refs.rtcPrivateVideo) {
						if (this.$refs.rtcPrivateVideo.onQuit) {
							this.$refs.rtcPrivateVideo.onQuit();
						} else if (this.$refs.rtcPrivateVideo.close) {
							this.$refs.rtcPrivateVideo.close();
						}
					}
				}
			});
			this.registerDismissable({
				id: `home-rtc-group-${this._uid}`,
				isOpen: () => Boolean(this.$refs.rtcGroupVideo && this.$refs.rtcGroupVideo.showRoom),
				getZIndex: () => resolveZIndex([
					this.$refs.rtcGroupVideo && this.$refs.rtcGroupVideo.$el
						? this.$refs.rtcGroupVideo.$el.querySelector('.custom-dialog')
						: null,
					this.$refs.rtcGroupVideo && this.$refs.rtcGroupVideo.$el
						? this.$refs.rtcGroupVideo.$el.querySelector('.taskbar-icon')
						: null
				], 999),
				close: () => {
					if (this.$refs.rtcGroupVideo) {
						if (this.$refs.rtcGroupVideo.onQuit) {
							this.$refs.rtcGroupVideo.onQuit();
						} else if (this.$refs.rtcGroupVideo.close) {
							this.$refs.rtcGroupVideo.close();
						}
					}
				}
			});
		},
		isElementVisible(element) {
			if (!element || typeof window === 'undefined' || !window.getComputedStyle) {
				return false;
			}
			const style = window.getComputedStyle(element);
			if (style.display === 'none' || style.visibility === 'hidden') {
				return false;
			}
			const rect = element.getBoundingClientRect();
			return rect.width > 0 && rect.height > 0;
		},
		hasVisibleFrameworkOverlay() {
			const selectors = [
				'.el-dialog__wrapper',
				'.el-drawer__wrapper',
				'.el-message-box__wrapper',
				'.v-modal'
			];
			return selectors.some((selector) => Array.from(document.querySelectorAll(selector))
				.some((element) => this.isElementVisible(element)));
		},
		getActiveRouteView() {
			const routeView = this.$refs.activeView;
			if (Array.isArray(routeView)) {
				return routeView[0] || null;
			}
			return routeView || null;
		},
		dispatchActiveViewEscape(event) {
			const routeView = this.getActiveRouteView();
			if (!routeView || typeof routeView.handleEscape !== 'function') {
				return false;
			}
			try {
				return Boolean(routeView.handleEscape(event));
			} catch (error) {
				console.error('处理页面 Escape 事件失败', error);
				return false;
			}
		},
		isEditableEventTarget(target) {
			let element = target;
			while (element && element.nodeType !== 1) {
				element = element.parentElement;
			}
			if (!element) {
				return false;
			}
			if (element.isContentEditable) {
				return true;
			}
			const tagName = String(element.tagName || '').toLowerCase();
			if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
				return true;
			}
			return typeof element.closest === 'function'
				&& Boolean(element.closest('[contenteditable="true"], .el-input__inner, .el-textarea__inner'));
		},
		onGlobalKeydown(event) {
			if (!event || event.key !== 'Escape') {
				return;
			}
			if (this.hasVisibleFrameworkOverlay()) {
				return;
			}
			if (dismissStack.dismissTop()) {
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			if (this.dispatchActiveViewEscape(event)) {
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			if (this.isEditableEventTarget(event.target)) {
				return;
			}
		},
		closeAllBox() {
			if (this.$refs.groupInfo && this.$refs.groupInfo.close) {
				this.$refs.groupInfo.close();
			}
			if (this.$refs.userInfo && this.$refs.userInfo.close) {
				this.$refs.userInfo.close();
			}
			if (this.$refs.userProfileCard && this.$refs.userProfileCard.close) {
				this.$refs.userProfileCard.close();
			}
			if (this.$refs.fullImage && this.$refs.fullImage.close) {
				this.$refs.fullImage.close();
			}
			if (this.$refs.fullVideo && this.$refs.fullVideo.close) {
				this.$refs.fullVideo.close();
			}
			if (this.$refs.previewFile && this.$refs.previewFile.close) {
				this.$refs.previewFile.close();
			}
		},
		playAudioTip() {
			// 播放间隔必须大于1s
			let interval = new Date().getTime() - this.lastPlayAudioTime;
			if (this.mine.isAudioTip && interval > 1000) {
				if (!this.audio) {
					this.audio = new Audio();
					this.audio.src = require(`@/assets/audio/tip.mp3`);
				}
				this.lastPlayAudioTime = new Date().getTime();
				this.audio.play();
			}
		},
		async resolveNotificationIcon(icon) {
			if (!icon) {
				return 'logo.png';
			}
			try {
				return await this.$assetResolver.resolveUrl(icon, {
					kind: 'image'
				});
			} catch (error) {
				console.warn('解析通知头像失败', error);
				return 'logo.png';
			}
		},
		showNotification(chat, title, icon) {
			// 消息提醒
			if (window.Notification && window.electronAPI) {
				const requestId = ++this.notificationRequestId;
				// 当窗口失去焦点，则弹出通知消息
				window.electronAPI.invoke("isFocused").then(foucus => {
					if (!foucus && requestId === this.notificationRequestId) {
						this.resolveNotificationIcon(icon).then((iconPath) => {
							if (requestId !== this.notificationRequestId || this.exiting) {
								return;
							}
							this.notification && this.notification.close();
							this.notification = new Notification(title, {
								body: chat.lastContent,
								icon: iconPath
							})
							// 点击通知消息，激活聊天会话
							this.notification.onclick = () => {
								this.chatStore.openChat(chat);
								this.chatStore.setActiveChat(chat);
								this.$router.push("/home/chat");
								// 唤醒在后台的客户端
								window.electronAPI.sendEvent("show");
							}
						});
					}
				})
			}
		},
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: "",
					headImage: "",
					userName: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "",
					headImageThumb: ""
				}
			}
			return group;
		},
		findRecentGroupChatSummary(groupId) {
			const groupKey = String(groupId ?? '');
			if (!groupKey) {
				return null;
			}
			const recentChats = Array.isArray(this.recentSessionRestoreCache)
				? this.recentSessionRestoreCache
				: [];
			return recentChats.find((recentChat) => {
				if (!recentChat || Number(recentChat.chatType) !== 2) {
					return false;
				}
				return String(recentChat.targetId ?? '') === groupKey;
			}) || null;
		},
		resolveGroupConversationDisplayName(group, recentChat = null, existingChat = null) {
			return pickGroupDisplayName(
				resolveGroupChatDisplayName(group),
				group && group.remarkGroupName,
				group && group.name,
				recentChat && recentChat.showName,
				existingChat && existingChat.showName
			);
		},
		loadRecentChats(limit = RECENT_SESSION_RESTORE_LIMIT) {
			return this.fetchRecentChatPage({
				cursor: '',
				limit
			});
		},
		fetchRecentChatPage({ cursor = '', limit = RECENT_CHAT_PAGE_LIMIT } = {}) {
			const safeLimit = Math.max(1, Math.min(RECENT_CHAT_MAX_PAGE_LIMIT,
				toNumber(limit, RECENT_CHAT_PAGE_LIMIT) || RECENT_CHAT_PAGE_LIMIT));
			const params = new URLSearchParams();
			params.set('limit', String(safeLimit));
			if (cursor) {
				params.set('cursor', String(cursor));
			}
			return this.$http({
				url: `/message/recentChats?${params.toString()}`,
				method: 'get'
			}).then((payload) => normalizeRecentChatPagePayload(payload));
		},
		setRecentChatPageState(page) {
			const more = Boolean(page && page.more && page.cursor);
			this.recentSessionPage = {
				cursor: more ? String(page.cursor) : '',
				more,
				total: Math.max(0, Math.floor(toNumber(page && page.total, this.recentSessionPage.total)))
			};
			this.recentSessionPaginationPrimed = true;
		},
		primeRecentChatPaginationState(options = {}) {
			if (this.recentSessionPaginationPrimePromise) {
				return this.recentSessionPaginationPrimePromise;
			}
			if (this.recentSessionPaginationPrimed || this.recentSessionPage.more || this.recentSessionPage.cursor) {
				return Promise.resolve(null);
			}
			if (options.force !== true) {
				const sinceFailure = Date.now() - Number(this.recentSessionRestoreLastFailureAt || 0);
				if (sinceFailure >= 0 && sinceFailure < RECENT_CHAT_RESTORE_RETRY_COOLDOWN_MS) {
					return Promise.resolve(null);
				}
			}
			const task = this.loadRecentChats(RECENT_CHAT_FIRST_PAGE_LIMIT).then((page) => {
				const items = Array.isArray(page.items) ? page.items : [];
				this.recentSessionRestoreCache = items.slice();
				this.setRecentChatPageState(page);
				this.recentSessionRestoreLastFailureAt = 0;
				return page;
			}).catch((error) => {
				this.recentSessionRestoreLastFailureAt = Date.now();
				console.warn('预热最近会话分页状态失败', error);
				return null;
			}).finally(() => {
				this.recentSessionPaginationPrimePromise = null;
			});
			this.recentSessionPaginationPrimePromise = task;
			return task;
		},
		appendRecentSessionCache(items = []) {
			if (!Array.isArray(items) || items.length === 0) {
				return;
			}
			const merged = Array.isArray(this.recentSessionRestoreCache)
				? this.recentSessionRestoreCache.slice()
				: [];
			const keySet = new Set(merged.map((item) => {
				if (!item || !item.targetId || !item.chatType) {
					return '';
				}
				return `${item.chatType}:${item.targetId}`;
			}).filter(Boolean));
			items.forEach((item) => {
				if (!item || !item.targetId || !item.chatType) {
					return;
				}
				const key = `${item.chatType}:${item.targetId}`;
				if (keySet.has(key)) {
					return;
				}
				keySet.add(key);
				merged.push(item);
			});
			this.recentSessionRestoreCache = merged;
		},
		loadMoreRecentChatsForSessionList(options = {}) {
			if (this.recentSessionBackgroundPromise) {
				return this.recentSessionBackgroundPromise;
			}
			if (!this.recentSessionPage.more || !this.recentSessionPage.cursor) {
				return Promise.resolve(0);
			}
			const pageBudget = Math.max(1, Math.floor(toNumber(options.maxPages, 1) || 1));
			const pageLimit = Math.max(1, Math.min(RECENT_CHAT_MAX_PAGE_LIMIT,
				toNumber(options.limit, RECENT_CHAT_PAGE_LIMIT) || RECENT_CHAT_PAGE_LIMIT));
			let cursor = this.recentSessionPage.cursor;
			let more = this.recentSessionPage.more;
			let loadedCount = 0;
			let loadedItems = [];
			const task = (async () => {
				for (let idx = 0; idx < pageBudget && more && cursor; idx += 1) {
					const page = await this.fetchRecentChatPage({
						cursor,
						limit: pageLimit
					});
					const nextItems = Array.isArray(page.items) ? page.items : [];
					this.appendRecentSessionCache(nextItems);
					loadedItems = loadedItems.concat(nextItems);
					this.setRecentChatPageState(page);
					loadedCount += nextItems.length;
					cursor = this.recentSessionPage.cursor;
					more = this.recentSessionPage.more;
				}
				if (loadedCount > 0) {
					const restoredCount = this.replayRecentChatSummaries(loadedItems);
					if (restoredCount > 0) {
						this.chatStore.refreshChats();
					}
				}
				return loadedCount;
			})();
			this.recentSessionBackgroundPromise = task.catch((error) => {
				console.warn('会话列表滚动续拉最近会话失败', error);
				return 0;
			}).finally(() => {
				this.recentSessionBackgroundPromise = null;
			});
			return this.recentSessionBackgroundPromise;
		},
		async ensureRecentChatsFullyLoaded(options = {}) {
			const pageLimit = Math.max(1, Math.min(RECENT_CHAT_MAX_PAGE_LIMIT,
				toNumber(options.limit, RECENT_CHAT_PAGE_LIMIT) || RECENT_CHAT_PAGE_LIMIT));
			const maxPages = Math.max(1, Math.floor(toNumber(options.maxPages, 500) || 500));
			let loadedPages = 0;
			while (loadedPages < maxPages && this.recentSessionPage.more && this.recentSessionPage.cursor) {
				const previousCursor = this.recentSessionPage.cursor;
				await this.loadMoreRecentChatsForSessionList({
					...options,
					limit: pageLimit,
					maxPages: 1
				});
				loadedPages++;
				if (this.recentSessionPage.more && this.recentSessionPage.cursor === previousCursor) {
					break;
				}
			}
			return Array.isArray(this.recentSessionRestoreCache) ? this.recentSessionRestoreCache : [];
		},
		restoreRecentPrivateChatShells(recentChats = []) {
			let restoredCount = 0;
			recentChats.forEach((recentChat) => {
				if (!recentChat || !recentChat.targetId) {
					return;
				}
				const friend = this.friendStore.findFriend(recentChat.targetId);
				const existingChat = this.chatStore.findChat({
					type: 'PRIVATE',
					targetId: recentChat.targetId
				});
				this.chatStore.restoreChatShell({
					type: 'PRIVATE',
					targetId: recentChat.targetId,
					showName: friend
						? (resolvePrivateDisplayName(friend) || friend.showNickName || friend.nickName || friend.userName || recentChat.showName || (existingChat && existingChat.showName) || '')
						: (recentChat.showName || recentChat.userName || (existingChat && existingChat.showName) || ''),
					headImage: friend ? (friend.headImage || '') : (recentChat.headImage || ''),
					userName: friend ? (friend.userName || '') : (recentChat.userName || '')
				}, {
					lastMessage: recentChat,
					optTime: this.toTimestamp(recentChat.sendTime)
				});
				restoredCount++;
			});
			return restoredCount;
		},
		restoreRecentGroupChatShells(recentChats = []) {
			let restoredCount = 0;
			recentChats.forEach((recentChat) => {
				if (!recentChat || !recentChat.targetId) {
					return;
				}
				const targetId = recentChat.targetId;
				const group = this.groupStore.findGroup(targetId);
				if (group && (group.quit || group.dissolve)) {
					return;
				}
				const latestSendTime = this.toTimestamp(recentChat.sendTime);
				const clearTs = group ? this.toTimestamp(group.messageClearTime) : 0;
				if (clearTs > 0 && latestSendTime > 0 && latestSendTime <= clearTs) {
					return;
				}
				const chatKey = {
					type: 'GROUP',
					targetId
				};
				const existingChat = this.chatStore.findChat(chatKey);
				const showName = this.resolveGroupConversationDisplayName(group, recentChat, existingChat);
				const headImage = (group && (group.headImageThumb || group.headImage))
					|| recentChat.headImage
					|| (existingChat && existingChat.headImage)
					|| '';
				this.chatStore.restoreChatShell({
					type: 'GROUP',
					targetId,
					showName,
					headImage
				}, {
					lastMessage: recentChat,
					optTime: latestSendTime
				});
				restoredCount++;
			});
			return restoredCount;
		},
		replayRecentChatSummaries(recentChats = []) {
			const recentList = Array.isArray(recentChats) ? recentChats : [];
			if (recentList.length === 0) {
				return 0;
			}
				const privateChats = [];
			const groupChats = [];
			recentList.forEach((recentChat) => {
				if (!recentChat || !recentChat.targetId) {
					return;
				}
				if (Number(recentChat.chatType) === 1) {
					privateChats.push(recentChat);
					return;
				}
				if (Number(recentChat.chatType) === 2) {
					groupChats.push(recentChat);
				}
			});
			let restoredCount = this.restoreRecentPrivateChatShells(privateChats);
			restoredCount += this.restoreRecentGroupChatShells(groupChats);
			return restoredCount;
		},
		restoreRecentSessionsIfNeeded(options = {}) {
			const allowWithoutDeps = options.allowWithoutDeps === true;
			const primeOnly = options.primeOnly === true;
			const refreshCache = options.refreshCache === true;
			const forceReplay = options.forceReplay === true;
			if (this.restoringRecentSessions) {
				return this.recentSessionRestorePromise || Promise.resolve(0);
			}
		if (!allowWithoutDeps && !this.recentSessionRestoreDepsReady) {
			return Promise.resolve(0);
		}
			if (primeOnly && this.recentSessionsPrimed) {
				return Promise.resolve(0);
			}
			if (!primeOnly && this.recentSessionsRestored && !refreshCache && !forceReplay) {
				return Promise.resolve(0);
			}
			const hasRecentChatCache = Array.isArray(this.recentSessionRestoreCache)
				&& this.recentSessionRestoreCache.length > 0;
			if (primeOnly && !hasRecentChatCache) {
				return Promise.resolve(0);
			}
				const shouldRefreshRemote = refreshCache === true || (!primeOnly && !hasRecentChatCache);
				const useRemoteSource = !(!shouldRefreshRemote && hasRecentChatCache);
				if (useRemoteSource && !forceReplay && !refreshCache) {
					const now = Date.now();
					const sinceFailure = now - Number(this.recentSessionRestoreLastFailureAt || 0);
					if (sinceFailure >= 0 && sinceFailure < RECENT_CHAT_RESTORE_RETRY_COOLDOWN_MS) {
						return Promise.resolve(0);
					}
				}
				this.restoringRecentSessions = true;
				let restoredCount = 0;
				const recentChatsSource = (!shouldRefreshRemote && hasRecentChatCache)
					? this.recentSessionRestoreCache
					: this.loadRecentChats(RECENT_CHAT_FIRST_PAGE_LIMIT).then((page) => {
						const items = Array.isArray(page.items) ? page.items : [];
						this.recentSessionRestoreCache = items.slice();
						this.setRecentChatPageState(page);
						this.recentSessionRestoreLastFailureAt = 0;
						return this.recentSessionRestoreCache;
					});
				this.recentSessionRestorePromise = Promise.resolve(recentChatsSource).then((recentChats) => {
					const replayedCount = this.replayRecentChatSummaries(recentChats);
					if (forceReplay) {
						restoredCount = 0;
					}
					restoredCount += replayedCount;
					if (restoredCount > 0) {
						this.chatStore.refreshChats();
					}
				this.recentSessionsPrimed = true;
				if (!primeOnly) {
					this.recentSessionsRestored = true;
				}
					return restoredCount;
				}).catch((error) => {
					console.warn('恢复最近会话摘要失败', error);
					if (useRemoteSource) {
						this.recentSessionRestoreLastFailureAt = Date.now();
					}
					return restoredCount;
				}).finally(() => {
				this.restoringRecentSessions = false;
				this.recentSessionRestorePromise = null;
			});
			return this.recentSessionRestorePromise;
		},
		showUserProfile(event) {
			const trigger = event && event.currentTarget ? event.currentTarget : null;
			const nextPos = {
				x: 16,
				y: 16
			};
			if (trigger && typeof trigger.getBoundingClientRect === 'function') {
				const rect = trigger.getBoundingClientRect();
				nextPos.x = rect.right + 12;
				nextPos.y = rect.top;
			}
			this.openOverlayRef('userProfileCard', [nextPos], '个人资料卡片加载失败，请稍后重试');
		},
		// ========== 系统消息分发处理 ==========
		handleSystemMessageDispatch(msgInfo) {
			// 根据消息的 type 字段判断具体类型（与后端 MessageType 枚举对应）
			const messageType = msgInfo.type;

			if (messageType === this.$enums.MESSAGE_TYPE.CONFIG_CHANGED) {
				// 全局配置变更 (type=55)
				this.handleConfigChanged(msgInfo);
			} else if (messageType === this.$enums.MESSAGE_TYPE.ROLE_CHANGED) {
				// 用户角色变更 (type=56)
				this.handleRoleChanged(msgInfo);
			} else if (messageType === this.$enums.MESSAGE_TYPE.ROLE_PERM_UPDATED) {
				// 角色权限更新 (type=57)
				this.handleRolePermUpdated(msgInfo);
			} else if (messageType === this.$enums.MESSAGE_TYPE.USER_INFO_CHANGED) {
				this.handleUserInfoChanged(msgInfo);
			} else if (messageType === this.$enums.MESSAGE_TYPE.FORCE_LOGOUT) {
				// 后台强制登出 (type=58)
				this.$wsApi.close(3000)
				const tip = msgInfo.content || "您已被强制下线";
				this.$alert(tip, "强制下线通知", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
			} else if (messageType === this.$enums.MESSAGE_TYPE.GROUP_PERM_CHANGED) {
				// 群组权限变更 (type=97)
				this.handleGroupPermChanged(msgInfo);
			} else if (messageType === this.$enums.MESSAGE_TYPE.MESSAGE_EDITED) {
				// 消息编辑 (type=13)
				this.handleMessageEdited(msgInfo);
			} else {
				// 其他系统消息（如 SYSTEM_MESSAGE type=53）
				this.handleSystemMessage(msgInfo);
			}
		},
		// ========== 配置变更处理方法 ==========
		handleConfigChanged(msgInfo) {
			// 全局配置变更，重新加载配置
			console.log("收到全局配置变更通知", msgInfo);
			this.configStore.loadConfig({ force: true }).then(() => {
				if (!this.ensureTenantAvailableOrExit()) {
					return;
				}
			}).catch(err => {
				console.error("加载全局配置失败", err);
			});
		},
		handleRoleChanged(msgInfo) {
			// 用户角色变更，重新加载用户信息和权限
			console.log("收到用户角色变更通知", msgInfo);
			Promise.all([
				this.userStore.loadUser(),
				this.userStore.loadPermissions()
			]).catch(err => {
				console.error("加载用户角色权限失败", err);
			});
		},
		handleRolePermUpdated(msgInfo) {
			// 角色权限更新（当前用户所属角色的权限配置被管理员修改）
			console.log("收到角色权限更新通知", msgInfo);
			this.userStore.loadPermissions().catch(err => {
				console.error("加载角色权限失败", err);
			});
		},
		async handleUserInfoChanged(msgInfo) {
			let user = null;
			try {
				user = msgInfo.content ? JSON.parse(msgInfo.content) : null;
			} catch (err) {
				console.error("解析用户资料变更消息失败", err);
				return;
			}
			if (!user || !user.id) {
				return;
			}
			const normalizedUser = {
				...user,
				headImage: user.headImageThumb || user.headImage || ''
			};
			if (this.mine && this.mine.id == user.id) {
				this.userStore.setUserInfo({
					...this.mine,
					...user
				});
			}
			let friend = null;
			try {
				friend = await this.friendStore.patchFriendProfile(normalizedUser);
			} catch (error) {
				console.warn('持久化好友资料变更失败', error);
				friend = this.friendStore.findFriend(user.id);
			}
			if (friend) {
				this.groupStore.syncGroupMemberFromFriend(friend);
				this.chatStore.updateChatFromFriend(friend);
			}
			const changedGroupIds = this.groupStore.syncGroupMemberFromUser(user);
			if (!friend) {
				this.chatStore.updateChatFromUser(normalizedUser);
			}
			(Array.isArray(changedGroupIds) ? changedGroupIds : []).forEach((groupId) => {
				const group = this.groupStore.findGroup(groupId);
				if (group) {
					this.chatStore.updateChatFromGroup(group);
				}
			});
		},
		handleGroupPermChanged(msgInfo) {
			// 群组权限变更
			console.log("收到群组权限变更通知", msgInfo);
			// 解析 content 字段（后端发送的是 JSON 字符串）
			try {
				const content = JSON.parse(msgInfo.content);
				const groupId = content.groupId;
				const permissions = content.permissions || {};

				if (groupId) {
					this.groupStore.updateGroupPermissions(groupId, {
						isAllowViewMemberProfile: permissions.isAllowViewMemberProfile,
						isAllowViewOnlineCount: permissions.isAllowViewOnlineCount,
						isAllowViewHistory: permissions.isAllowViewHistory
					});
					const group = this.groupStore.findGroup(groupId);
					if (group) {
						this.chatStore.updateChatFromGroup(group);
					}
					if (permissions.isAllowViewOnlineCount === true) {
						this.groupStore.refreshMemberOnline(groupId).catch(() => []);
					}
				}
			} catch (err) {
				console.error("解析群组权限变更消息失败", err);
			}
		},
		handleMessageEdited(msgInfo) {
			// 消息编辑
			console.log("收到消息编辑通知", msgInfo);
			// msgInfo 应该包含编辑后的完整消息对象
			// 根据消息类型更新对应的会话
			if (msgInfo.type !== undefined) {
				let chatInfo;
				if (msgInfo.groupId) {
					// 群聊消息
					chatInfo = {
						type: 'GROUP',
						targetId: msgInfo.groupId
					};
				} else {
					// 私聊消息
					const friendId = msgInfo.sendId === this.mine.id ? msgInfo.recvId : msgInfo.sendId;
					chatInfo = {
						type: 'PRIVATE',
						targetId: friendId
					};
				}
				// 更新消息
				this.chatStore.updateMessage(msgInfo, chatInfo);
			}
		}
	},
	computed: {
		mine() {
			return (this.userStore && this.userStore.userInfo) || {};
		},
		displayNickName() {
			const mine = this.mine || {};
			return mine.nickName || mine.userName || '';
		},
		displayUserName() {
			const mine = this.mine || {};
			return mine.userName || '';
		},
		unreadCount() {
			return this.chatStore.totalUnreadCount || 0;
		},
		recvCount() {
			let requests = this.friendStore.requests;
			if (!this.mine.id) {
				return 0;
			}
			return requests.filter((req) => req.recvId == this.mine.id).length;
		},
		themeIcon() {
			return this.configStore.theme === 'dark' ? 'el-icon-moon' : 'el-icon-sunny';
		},
		themeTitle() {
			return this.configStore.theme === 'dark' ? '切换到亮色模式' : '切换到暗色模式';
		},
		currentRouteTitle() {
			const map = {
				'/home/chat': '会话',
				'/home/friend': '联系人',
				'/home/group': '群管理'
			};
			return map[this.$route.path] || '会话';
		},
		recentSessionRestoreHasMore() {
			const page = this.recentSessionPage || {};
			return Boolean(page.more && page.cursor);
		},
		recentSessionRestoreCursor() {
			const page = this.recentSessionPage || {};
			return page.cursor ? String(page.cursor) : '';
		},
		recentSessionRestoreTotal() {
			const page = this.recentSessionPage || {};
			return Math.max(0, Math.floor(toNumber(page.total, 0)));
		},
		settingsDrawerSize() {
			return this.configStore.isMobile ? '88%' : '360px';
		},
		useSessionMobileChrome() {
			const sessionChromeRoutes = ['/home/chat', '/home/friend', '/home/group'];
			if (!sessionChromeRoutes.includes(this.$route.path)) {
				return false;
			}
			if (this.$route.path !== '/home/chat') {
				return true;
			}
			return !(this.configStore.isMobile && this.chatStore.activeChat);
		},
		mobileChromeClass() {
			return {
				'mobile-chrome--session': this.useSessionMobileChrome
			};
		}
	},
	watch: {
		'$route.fullPath'() {
			this.closeSettingsPanel();
			this.closeAllBox();
		},
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
				// 控制托盘图标闪烁
				if (window.electronAPI) {
					if (newCount > 0) {
						// 有未读消息时，检查窗口是否在焦点
						window.electronAPI.invoke('isFocused').then(foucus => {
							if (!foucus) {
								// 窗口不在焦点时开始闪烁
								window.electronAPI.sendEvent('startTrayBlink');
							}
						});
					} else {
						// 没有未读消息时停止闪烁
						window.electronAPI.sendEvent('stopTrayBlink');
					}
				}
			},
			immediate: true
		}
	},
	mounted() {
		this.$wsApi.close();
		this.init();
		this.scheduleWorkspaceRoutePreload();
		this.startConfigRefreshLoop();
		syncWorkspaceWindow();
		document.addEventListener('keydown', this.onGlobalKeydown, true);
		document.addEventListener('visibilitychange', this.flushPendingStorageOnPageLifecycle, true);
		if (typeof window !== 'undefined') {
			window.addEventListener('offline', this.onBrowserOffline);
			window.addEventListener('online', this.onBrowserOnline);
			window.addEventListener('pagehide', this.flushPendingStorageOnPageLifecycle, true);
		}
		this.$nextTick(() => {
			this.registerShellDismissables();
		});
	},
	beforeDestroy() {
		this.exiting = true;
		this.unbindWorkspaceEvents();
		this.clearReconnectTimer();
		this.cancelWorkspaceRoutePreload();
		this.stopConfigRefreshLoop();
		document.removeEventListener('keydown', this.onGlobalKeydown, true);
		document.removeEventListener('visibilitychange', this.flushPendingStorageOnPageLifecycle, true);
		if (typeof window !== 'undefined') {
			window.removeEventListener('offline', this.onBrowserOffline);
			window.removeEventListener('online', this.onBrowserOnline);
			window.removeEventListener('pagehide', this.flushPendingStorageOnPageLifecycle, true);
		}
		this.clearDismissableRegistrations();
	},
	unmounted() {
		this.exiting = true;
		this.clearReconnectTimer();
		this.cancelWorkspaceRoutePreload();
		this.stopConfigRefreshLoop();
		this.$wsApi.close();
		document.removeEventListener('keydown', this.onGlobalKeydown, true);
		document.removeEventListener('visibilitychange', this.flushPendingStorageOnPageLifecycle, true);
		if (typeof window !== 'undefined') {
			window.removeEventListener('offline', this.onBrowserOffline);
			window.removeEventListener('online', this.onBrowserOnline);
			window.removeEventListener('pagehide', this.flushPendingStorageOnPageLifecycle, true);
		}
		this.clearDismissableRegistrations();
	}
}
</script>

<style scoped lang="scss">
@import "../assets/style/responsive";

.home-page {
	--mobile-chrome-height: 52px;
	height: 100%;
	width: 100%;
	min-width: 0;
	min-height: 0;
	display: flex;
	overflow: hidden;
	background: var(--im-background);

	.app-container {
		width: 100%;
		height: 100%;
		min-width: 0;
		min-height: 0;
		display: flex;
		position: relative;
		overflow: hidden;
		transition: 0.2s;

		// 非桌面端: 纵向布局
		@include not-desktop {
			flex-direction: column;
		}
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 78px;
		width: var(--width);
		background: var(--im-navi-bg);
		padding-top: 20px;
		position: relative;
		border-right: 1px solid var(--im-surface-panel-border);
		flex-shrink: 0;

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.bottom {
				margin-bottom: 22px;
			}
		}

		.avater {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 7px;
			margin-bottom: 14px;
			cursor: pointer;
			transition: opacity 0.2s ease;

			:deep(.head-image) {
				border-radius: 12px;
				transition: opacity 0.2s ease;

				&:hover {
					opacity: 0.85;
				}
			}

			.avater-tenant {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				max-width: 70px;
				min-height: 20px;
				padding: 0 8px;
				border: none;
				font-size: 11px;
				font-weight: 500;
				color: var(--im-navi-chip-text);
				background: var(--im-navi-chip-bg);
				border-radius: 999px;
				line-height: 20px;
				cursor: default;

				i {
					display: none;
				}

				span {
					display: block;
					min-width: 0;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					text-align: center;
				}

			}
		}

		.menu {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			margin-top: 22px;
			gap: 5px;

			.link {
				text-decoration: none;
				display: block;
				width: 100%;
			}

			.router-link-active .menu-item {
				color: var(--im-navi-text);
				background: var(--im-navi-active-bg);
			}

			.link:not(.router-link-active) .menu-item:hover {
				background: var(--im-navi-hover-bg);
				color: var(--im-navi-text);
			}

			.menu-item {
				position: relative;
				color: var(--im-navi-text-muted);
				width: 100%;
				min-height: 54px;
				padding: 9px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 5px;
				margin: 0;
				border-radius: 0;
				transition: background-color 0.2s ease, color 0.2s ease;
				cursor: pointer;

				.menu-label {
					font-size: 11px;
					line-height: 1;
					font-weight: 500;
					letter-spacing: 0.01em;
					white-space: nowrap;
				}

				.unread-text {
					position: absolute;
					background: var(--im-color-danger);
					right: 10px;
					top: 5px;
					color: white;
					border-radius: 999px;
					padding: 0 5px;
					font-size: 10px;
					font-weight: 600;
					text-align: center;
					white-space: nowrap;
					border: 2px solid var(--im-navi-bg);
					box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
					min-width: 18px;
					height: 18px;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: 18px;
					z-index: 1;
				}
			}

			.menu-item__icon,
			.bottom-item__icon {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 24px;
				height: 22px;
				min-width: 24px;
				font-size: 20px;
				line-height: 1;
				transform: translateY(0);
				transition: color 0.2s ease, transform 0.2s ease;
			}

			.menu-item__icon--friend {
				font-size: 20px;
				transform: translateY(0);
			}
		}

		.bottom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 40px;
			width: calc(100% - 12px);
			cursor: pointer;
			color: var(--im-navi-text-muted);
			font-size: var(--icon-font-size);
			border-radius: 10px;
			margin: 2px auto;
			transition: background-color 0.2s ease, color 0.2s ease;
			position: relative;

			&:hover {
				color: var(--im-navi-text);
				background: var(--im-navi-hover-bg);
			}
		}

		.bottom-item--active {
			color: var(--im-navi-text);
			background: var(--im-navi-active-bg);
		}
	}

	.content-box {
		flex: 1;
		min-width: 0;
		min-height: 0;
		padding: 0;
		background: var(--im-background);
		text-align: center;
		overflow: hidden;

		// 非桌面端: 给底部 tab bar 留空间
		@include not-desktop {
			padding-bottom: calc(var(--mobile-chrome-height) + env(safe-area-inset-bottom, 0px));
		}
	}

	// 移动端/平板端底部 tab bar
	.mobile-tab-bar {
		--mobile-chrome-bg: var(--im-chat-bg);
		--mobile-chrome-border: var(--im-border-color);
		--mobile-chrome-text: var(--im-text-color-primary);
		--mobile-chrome-muted: var(--im-text-color-light);
		--mobile-chrome-hover: var(--im-background-active);
		--mobile-chrome-active: var(--im-color-primary);
		--mobile-chrome-indicator: var(--im-color-primary);
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 100;
		height: calc(var(--mobile-chrome-height) + env(safe-area-inset-bottom, 0px));
		padding-bottom: env(safe-area-inset-bottom, 0px);
		display: flex;
		align-items: center;
		justify-content: space-around;
		background: var(--mobile-chrome-bg);
		border-top: 1px solid var(--mobile-chrome-border);

		.tab-item {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 2px;
			width: 68px;
			padding: 6px 4px 4px;
			border-radius: 0;
			text-decoration: none;
			color: var(--mobile-chrome-muted);
			transition: color 0.2s ease, opacity 0.2s ease;

			.tab-label {
				font-size: 10px;
				font-weight: 500;
				line-height: 1;
			}

			.tab-badge {
				position: absolute;
				top: 3px;
				right: 8px;
				background: var(--im-color-danger);
				color: white;
				border-radius: 999px;
				padding: 0 5px;
				font-size: 10px;
				font-weight: 600;
				min-width: 18px;
				height: 18px;
				display: flex;
				align-items: center;
				justify-content: center;
				line-height: 18px;
				border: 2px solid var(--mobile-chrome-bg);
				box-shadow: 0 1px 3px rgba(var(--im-black-rgb), 0.15);
			}

			&.router-link-active {
				color: var(--mobile-chrome-active);

				.tab-label {
					font-weight: 600;
				}
			}

			&:not(.router-link-active):hover {
				color: var(--mobile-chrome-text);
			}
		}

		.tab-item__icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			min-width: 22px;
			font-size: 21px;
			line-height: 1;
			transform: translateY(-0.5px);
		}

		.tab-item__icon--friend {
			font-size: 22px;
			transform: translateY(-0.5px) scale(1.05);
		}

		.tab-item__icon--group {
			font-size: 21px;
		}

		&.mobile-chrome--session {
			--mobile-chrome-bg: var(--im-session-bg);
			--mobile-chrome-border: var(--im-surface-panel-border);
			--mobile-chrome-text: var(--im-session-text);
			--mobile-chrome-muted: var(--im-session-text-muted);
			--mobile-chrome-hover: var(--im-session-hover-bg);
			--mobile-chrome-active: var(--im-session-text);
			--mobile-chrome-indicator: var(--im-color-primary);
		}
	}

	// 移动端顶部栏
	.mobile-header-bar {
		--mobile-chrome-bg: var(--im-chat-bg);
		--mobile-chrome-border: var(--im-border-color);
		--mobile-chrome-text: var(--im-text-color-primary);
		--mobile-chrome-muted: var(--im-text-color-light);
		--mobile-chrome-hover: var(--im-background-active);
		--mobile-chrome-active: var(--im-color-primary);
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: var(--mobile-chrome-height);
		padding: 0 12px;
		position: sticky;
		top: 0;
		z-index: 30;
		border-bottom: 1px solid var(--mobile-chrome-border);
		background: var(--mobile-chrome-bg);

		.mobile-header-left {
			display: flex;
			align-items: center;
			gap: 10px;
			min-width: 0;

			.mobile-header-avatar {
				flex-shrink: 0;
				cursor: pointer;

				:deep(.head-image) {
					border-radius: 10px;
				}
			}

			.mobile-header-info {
				display: flex;
				flex-direction: column;
				min-width: 0;

				.mobile-header-title {
					font-size: 16px;
					font-weight: 600;
					color: var(--mobile-chrome-text);
					line-height: 1.2;
				}

				.mobile-header-tenant {
					display: inline-flex;
					align-items: center;
					margin-top: 4px;
					padding: 0;
					font-size: 11px;
					color: var(--mobile-chrome-muted);
					line-height: 1.2;

					span {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.mobile-header-right {
			display: flex;
			align-items: center;
			gap: 4px;

			.mobile-header-btn {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 34px;
				height: 34px;
				border-radius: 6px;
				cursor: pointer;
				color: var(--mobile-chrome-muted);
				font-size: 16px;
				transition: background-color 0.2s ease, color 0.2s ease;

				.icon {
					font-size: 16px;
				}

				&:hover {
					background: var(--mobile-chrome-hover);
					color: var(--mobile-chrome-active);
				}
			}
		}

		&.mobile-chrome--session {
			--mobile-chrome-bg: var(--im-session-bg);
			--mobile-chrome-border: var(--im-surface-panel-border);
			--mobile-chrome-text: var(--im-session-text);
			--mobile-chrome-muted: var(--im-session-text-muted);
			--mobile-chrome-hover: var(--im-session-hover-bg);
			--mobile-chrome-active: var(--im-session-text);
		}
	}

	:deep(.home-settings-popper) {
		padding: 0 !important;
		border-radius: 14px !important;
		border: 1px solid var(--im-surface-panel-border) !important;
		box-shadow: 0 16px 32px rgba(var(--im-black-rgb), 0.12) !important;
		background: var(--im-surface-panel) !important;
		overflow: hidden;
	}

	:deep(.home-settings-drawer) {
		background: var(--im-surface-panel);

		.el-drawer__header {
			margin-bottom: 0;
			padding: 18px 18px 10px;
			color: var(--im-text-color);
			border-bottom: 1px solid var(--im-surface-panel-border);
		}

		.el-drawer__body {
			padding: 0;
			overflow: auto;
		}
	}
}
</style>
